import React from 'react'
import { Box, Typography } from '@mui/material'
import { LineMessage } from '@/features/internal/patient-messaging/types/patientMessaging'

interface LineChatMessageProps {
  message: LineMessage
}

const LineChatMessage: React.FC<LineChatMessageProps> = ({ message }) => {
  const isPharmacist = message.sender_type === 'pharmacist'
  const time = new Date(message.sent_at).toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isPharmacist ? 'flex-end' : 'flex-start',
        mb: 1.5,
      }}
    >
      <Box sx={{ maxWidth: '75%' }}>
        <Box
          sx={{
            px: 1.5,
            py: 1,
            borderRadius: 2,
            backgroundColor: isPharmacist ? '#E3F2FD' : '#F5F5F5',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
          }}
        >
          <Typography variant="body2">{message.content}</Typography>
        </Box>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 0.25,
            color: 'text.secondary',
            textAlign: isPharmacist ? 'right' : 'left',
          }}
        >
          {time}
        </Typography>
      </Box>
    </Box>
  )
}

export default LineChatMessage
